import React, { useEffect } from 'react'
import {
    Box, Container, Button
} from '@material-ui/core'


export default function Authorize(props){
        const getLeverAuthorize = () => {
            window.location.assign("/integrations/lever/authorize");
        };

    return (
        <Container className="authorize-box" style={{ marginTop: '75px' }}>
            <Box px={5} py={2} sx={{
                    width: 300,
                    height: 'auto',
                    minHeight:100,
                    marginTop: 0,
                    borderBottom: '4px solid #002C77',
                    boxShadow: '0px 0px 5px grey',
                    borderRadius: 5,
                    backgroundColor: 'white',
                    textAlign : 'center'
                }
            }>
                    <Box component="span" sx={{color:'#002C77', fontWeight:800}}>Authorize your Credentials</Box>
                    <br></br>
                    <small>Please authorize via Lever using the button below</small>
                    <Button variant="contained" className="authorize-button bg-mettl-blue" mx={5} onClick={getLeverAuthorize}>Authorize via Lever</Button>
            </Box>
        </Container>
        )
}